import { Workorders } from "../../workorders/Workorders";

/**
 * Interventions Tab Component
 * Affiche la liste des interventions (workorders) pour un client spécifique en réutilisant le composant principal
 */
const InterventionsTab = ({ data }: { data: EasyTech.Customer }) => {
  return <Workorders customer={data} hideHeader={false} hideFilters={false} noPadding={true} />;
};

export default InterventionsTab;
